import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Produtos from "./pages/Produtos";
import Empresa from "./pages/Empresa";
import Contato from "./pages/Contato";
import NotFound from "./pages/NotFound";

import WhatsAppButton from "./components/WhatsAppButton";

import "./App.css";
import Produto from "./pages/Produto";

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/produtos" element={<Produtos />} />
            <Route path="/empresa" element={<Empresa />} />
            <Route path="/produto/:id" element={<Produto />} />
            <Route path="/contato" element={<Contato />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton /> 
      </div>
    </Router>
  );
}
export default App;
